import './Categories.css';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import sanityClient from '../../sanityClient.js';
import { categoriesQuery } from '../../queries/categoryQuery.js';
import { StandardLayout } from '../../layouts/StandardLayout.js';

export default function Categories(){
    const [categoryData, setCategoryData] = useState(null);

    useEffect(() => {
        sanityClient.fetch(categoriesQuery)
        .then((data) => setCategoryData(data))
        .catch(console.error)
    }, [])

    let content = null;
    if(categoryData){
        categoryData.sort((a, b) => {
            const titleA = a.title.toLowerCase();
            const titleB = b.title.toLowerCase();
            if(titleA < titleB) return -1;
            if(titleA > titleB) return 1;
            return 0;
        })
        content = 
            <ul className="categoriesList">
                {categoryData.map((category) => 
                    <li key={category._id}>
                        <Link to={`/categories/${category.slug.current}`}>{category.title}</Link>
                    </li>
                )}
            </ul>
    } else{
        content = "Loading..."
    }

    return(
        <StandardLayout title={"browse by category"} content={content} />
    )
}
